import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot
} from "@angular/router";
import { inject, Injectable } from "@angular/core";
import { SessionService } from "src/app/services/session.service";
import { sntNavigate } from "src/app/support/router";

@Injectable()
export class SessionGuard {
  private readonly sessionService = inject(SessionService);
  private readonly router = inject(Router);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    if (this.sessionService.isLocked()) {
      sntNavigate(this.router, ["/locked"]);
      return false;
    }

    return true;
  }
}
